module.exports = __webpack_public_path__ + "img/7left-b54e13b8.png";